import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const BankEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/banks/${id}`)
      .then((res) => {
        setInputs(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    Http.put(`/accounts/banks/${id}`, inputs)
      .then((res) => {
        navigate("/banks", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Bank</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Bank Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>Bank Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Enter Bank Name"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Account Number <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="account_number"
                      value={inputs.account_number || ""}
                      onChange={handleChange}
                      placeholder="Enter Account Number"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Branch Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="branch"
                      value={inputs.branch || ""}
                      onChange={handleChange}
                      placeholder="Enter Branch Name"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Balance</label>
                    <input
                      type="number"
                      className="form-control"
                      name="balance"
                      value={inputs.balance || ""}
                      onChange={handleChange}
                      placeholder="Enter Balance"
                      disabled
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  {/* <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                      placeholder="Enter Description"
                      rows="3"
                    ></textarea>
                  </div> */}
                  <div className="col-lg-3">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      onChange={handleChange}
                      value={inputs.status || ""}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankEdit;